import type { SortBarOption } from '@/features/sort-desktop-v1/sort-bar/sort-bar';

import { useSortModalFilterGroup } from '@/features/filter/filter-data/filter-data-attributes-state';
import { useSortFilterDataMutation } from '@/features/filter/filter-data/use-filter-data-mutation';
import SortBar from '@/features/sort-desktop-v1/sort-bar/sort-bar';

export default function SortDesktopV1Container() {
    const sortModalFilterGroup = useSortModalFilterGroup();
    const toggleSortFilter = useSortFilterDataMutation();

    if (!sortModalFilterGroup) {
        return null;
    }

    const selectedOption = sortModalFilterGroup.options.find((option) => option.isSelected);
    if (!selectedOption) {
        return null;
    }

    const onClickOption = (option: SortBarOption) => {
        toggleSortFilter(option.name);
    };

    return (
        <SortBar
            key={selectedOption.name}
            onClickOption={onClickOption}
            options={sortModalFilterGroup.options.map((option) => ({
                info: option.info,
                isSelected: option.isSelected,
                label: option.title,
                name: option.name,
            }))}
        />
    );
}
